import ContinueButton from '@/shared-components/buttons/components/ContinueButton';
import XIcon from '@/shared-components/icons/components/public/XIcon';
import Text from '@/shared-components/text/components/Text';

import GenericPopup from './GenericPopup';

import './styles/ConfirmationDialog.css';

export default function ConfirmationDialog({ className = '', title, open, onClose, onCloseAction, onConfirm, closeButtonText, confirmButtonText, dialogText, loading, showCancelButton = true, opacity=false, blur=false, darkerBlur=false }) {
  return (
    <GenericPopup open={open} className={`confirmation-dialog-popup remove-scrollbar ${className}`.trim()} opacity={opacity} blur={blur} darkerBlur={darkerBlur}>
      <div className="confirmation-dialog-popup__header">
        <Text className="confirmation-dialog-popup__header-text">{title}</Text>
        <XIcon className="confirmation-dialog-popup__close" onClick={onClose}/>
      </div>

      <Text className="confirmation-dialog-popup__text" paragraph>{dialogText}</Text>

      <div className="confirmation-dialog-popup__actions">
        {showCancelButton && (
          <ContinueButton
            type="button"
            className="continue-button_two font-size-medium"
            onClick={onCloseAction || onClose}
          >
            {closeButtonText}
          </ContinueButton>
        )}
        <ContinueButton
          type="button"
          className="continue-button_two font-size-medium"
          loading={loading}
          onClick={onConfirm}
        >
          {confirmButtonText}
        </ContinueButton>
      </div>
    </GenericPopup>
  );
}
